import { DeleteOutlined } from '@ant-design/icons';
import { Button } from 'antd';
import { observer } from 'mobx-react-lite';
import * as React from 'react';

import { DictionarySettingsValueModel } from 'stores/models/fieldsSettings';

import { useDictionaryTableContext } from '../../context';

type Props = {
  entity: DictionarySettingsValueModel;
};

/**
 * Колонка с кнопкой для удаления строки
 * @param entity
 * @constructor
 */
const DeleteRowButton: React.FC<Props> = ({ entity }) => {
  const { store } = useDictionaryTableContext();

  const handleOnDelete = React.useCallback(() => {
    store.deleteItem(entity.id);
  }, [entity.id, store]);

  return (
    <Button type="link" icon={<DeleteOutlined />} onClick={handleOnDelete} />
  );
};

export default observer(DeleteRowButton);
